import React from 'react'
import "./Cart.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import Usernav from './Usernav';
import emptyCart from "../assets/image/Add to Cart.gif"
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useState } from 'react';
import axios from 'axios';
import GetProducts from './GetProducts';
import Loader from '../Util/Loader';
import BaseURL from '../Util/BaseURL';
const Cart = () => {
    const [products, setProducts] = useState();
    const [quantity, setQuantity]=useState(1)
    const [price,setPrice]=useState()
    const [total,setTotal]=useState()
    const [pro,setPro] = useState()
    async function getCartDetails() {
        const r = await axios.get(`${BaseURL}getCart?name=${sessionStorage.getItem("user")}`, { headers: { "Authorization": "Bearer " + sessionStorage.getItem("pic") } })
        setProducts(r.data)
    }
    
    var nav = useNavigate()
    function navigate() {
        nav('/Checkout')
    }
    useEffect(() => {
        getCartDetails();
    }, []);
    return (
        <>
           <Usernav/>      
            {products ? 
             <>
             {products.length === 0 ?
             <>
             <div>
             <section id="hero">
                <div className="hero-container">
                    <div className="hero-logo">
                        <h1 className="font-weight-bold"  id='carthead'>Your Shopping Cart is Empty</h1>
                    </div>
                </div>
            </section>
                <img src = {emptyCart} className="d-block d-xl-none d-lg-none d-md-none" style={{ width: "100%" }} />
                <img src = {emptyCart} className="d-none d-xl-block d-lg-block d-md-block mx-auto" style={{ width: "35%" }} />
             </div>
             </> 
             : 
             <>
             <section id="hero">
                <div className="hero-container">
                    <div className="hero-logo">
                        <h1 className="font-weight-bold"  id='carthead'>Your Shopping Cart</h1>
                    </div>
                </div>
            </section>
             <section className="">
                <div className="container">
                    <div className="cart">
                        <div className="table-responsive">
                            <table className="table">
                                <thead className="thead-dark">
                                    <tr>
                                        <th scope="col" className="text-white">Product</th>
                                        <th scope="col" className="text-white">Price</th>
                                        <th scope="col" className="text-white">Quantity</th>
                                        <th scope="col" className="text-white">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {products ? products.map((data,key) => (

                                    <GetProducts key={key} props={data.product_id} />
                                    )) : ""}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className='text-center'>
                               <div className="checkoutBtn">
                    <a onClick={() => navigate()}><button className="proceed-btn">Proceed to Checkout</button></a>
                </div>

            </div>
            </section>
             </>}
             </>
             :
             <>
             {Loader()}
             </>}
            
            
        </>
    );
}

export default Cart